import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { fmtTL, fmtNum } from "../../lib/format";

const th = (a) => `px-3 py-2 text-[10px] uppercase tracking-wider text-slate-600 font-semibold ${a === "r" ? "text-right" : "text-left"}`;
const num = "numeric-cell px-3 py-1.5 text-xs";
const HEAD = [["Proje", "l"], ["Personel", "r"], ["Gün", "r"], ["Toplam Brüt", "r"], ["Net", "r"], ["SGK İşveren", "r"], ["İşveren Maliyeti", "r"], ["Hakediş (KDV hariç)", "r"], ["Fark", "r"]];
const sum = (rows, k) => rows.reduce((a, r) => a + (Number(r[k]) || 0), 0);

// Proje / şube bazlı işveren maliyet özeti — dönemin müşteri hakedişiyle karşılaştırma (hakediş − işveren maliyeti)
export default function PayrollProjects({ projects, period, onPick, picked, testid = "payroll-projects" }) {
  if (!projects?.length) return null;
  const withClaim = projects.filter((g) => g.claim_total != null);
  return (
    <div className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-testid={testid}>
      <div className="px-4 py-2.5 border-b border-slate-100 bg-slate-50 flex flex-wrap items-center justify-between gap-2">
        <div>
          <div className="text-sm font-bold text-slate-900">Proje Bazlı Bordro — İşveren Maliyeti</div>
          <div className="text-[11px] text-slate-500">Proje adına tıklayınca tablo o projeye süzülür · Hakediş: dönemin müşteri hakediş faturası (taslak/onaylı), KDV hariç · Fark = hakediş − işveren maliyeti</div>
        </div>
        <span className="text-[11px] text-slate-500">{projects.length} proje · {withClaim.length} hakedişli</span>
      </div>
      <table className="w-full tbl">
        <thead><tr>{HEAD.map(([h, a]) => <th key={h} className={th(a)}>{h}</th>)}</tr></thead>
        <tbody>
          {projects.map((g) => (
            <tr key={g.project_id} className={`border-t border-slate-100 ${picked === g.project_id ? "bg-amber-50" : "hover:bg-slate-50"}`} data-testid={`${testid}-row-${g.project_id}`}>
              <td className="px-3 py-1.5 text-xs">
                <button type="button" onClick={() => onPick(picked === g.project_id ? "" : g.project_id)} className="font-semibold text-slate-900 hover:text-amber-800 text-left" data-testid={`${testid}-pick-${g.project_id}`}>{g.project_name}</button>
                {g.company && <span className="ml-1.5 px-1 py-0.5 rounded bg-sky-100 text-sky-800 text-[9px] font-bold uppercase">{g.company}</span>}
              </td>
              <td className={num}>{g.people}</td>
              <td className={num}>{fmtNum(g.days)}</td>
              <td className={num}>{fmtTL(g.gross)}</td>
              <td className={num}>{fmtTL(g.net)}</td>
              <td className={num}>{fmtTL(g.sgk_employer)}</td>
              <td className={`${num} font-semibold`}>{fmtTL(g.employer_cost)}</td>
              <td className={num}>
                {g.claim_total == null ? <span className="text-slate-300">—</span> : (
                  <Link to={`/musteri-hakedis?proje=${g.project_id}&bas=${period}-01&bit=${period}-28`} className={`inline-flex items-center gap-1 hover:underline ${g.claim_approved ? "text-emerald-700" : "text-amber-700"}`} title={`${g.claim_invoice_no || ""} ${g.claim_approved ? "(onaylı)" : "(taslak)"}`}>{fmtTL(g.claim_total)} <ExternalLink className="w-3 h-3" /></Link>
                )}
              </td>
              <td className={`${num} font-bold ${g.margin == null ? "text-slate-300" : g.margin < 0 ? "text-red-700" : "text-emerald-700"}`} data-testid={`${testid}-margin-${g.project_id}`}>{g.margin == null ? "—" : `${g.margin > 0 ? "+" : ""}${fmtTL(g.margin)}`}</td>
            </tr>
          ))}
        </tbody>
        <tfoot className="bg-slate-50 border-t-2 border-slate-300">
          <tr>
            <td className="px-3 py-2 text-xs font-bold uppercase tracking-wider text-slate-700">Toplam</td>
            <td className={`${num} font-bold`}>{sum(projects, "people")}</td>
            <td className={`${num} font-bold`}>{fmtNum(sum(projects, "days"))}</td>
            <td className={`${num} font-bold`}>{fmtTL(sum(projects, "gross"))}</td>
            <td className={`${num} font-bold`}>{fmtTL(sum(projects, "net"))}</td>
            <td className={`${num} font-bold`}>{fmtTL(sum(projects, "sgk_employer"))}</td>
            <td className={`${num} font-bold`}>{fmtTL(sum(projects, "employer_cost"))}</td>
            <td className={`${num} font-bold`}>{withClaim.length ? fmtTL(sum(withClaim, "claim_total")) : "—"}</td>
            <td className={`${num} font-bold ${sum(withClaim, "margin") < 0 ? "text-red-700" : "text-emerald-700"}`}>{withClaim.length ? fmtTL(sum(withClaim, "margin")) : "—"}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
